import { fetch } from '@/plugin/axios/index.js'
import formAxios from '@/plugin/axios/formAxios.js'

/**
 * @param {Object} data
 * 获取保养项列表
 */
export function getTermList(data) {
  return fetch ({
    url: '/maintain/maintain/item/itemList',
    method: 'POST',
    data
  })
}


/**
 * @param {Object} data
 * 添加保养项
 */
export function addTerm(data) {
  return fetch({
    url: '/maintain/maintain/item/save',
    method: 'POST',
    data
  })
}


/**
 * @param {Object} data
 * 删除保养项
 */
export function deleteTerm(data) {
  return fetch({
    url: '/maintain/maintain/item/delete',
    method: 'POST',
    data
  })
}



/**
 * @param {Object} data
 * 导出保养项
 */
export function exportTerm(data) {
  return formAxios({
    url: '/auth/unit/exportUnitList',
    method: 'POST',
    data
  })
}


/**
 * @param {Object} data
 * 获取维保部位
 */
export function getLocationSimpleList(params) {
  return fetch ({
    url: '/maintain/maintain/location/simpleList',
    method: 'GET',
    params
  })
}


/**
 * @param {Object} data
 * 获取维保类型
 */
export function getMaintainTypeList() {
  return fetch ({
    url: '/maintain/maintain/item/maintainTypeList',
    method: 'POST',
  })
}





// WEBPACK FOOTER //
// ./src/api/MaintenanceItems/index.js